/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, CircularProgress, Typography, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import AddIcon from '@mui/icons-material/Add';
import { useState } from "react";
import CustomInput from "../../inputs/customInput";
import CityDropdown from "../../dropdowns/cityDropdown";
import { useTheme } from "@emotion/react";
import CityPriceService from "../../../services/cityPriceService";
import BranchDropdown from "../../dropdowns/branchDropdown";

const AddCityPriceBox = ({
    handleReload,
    setPopupMsg,
    setPopupType,
    setShowPopup }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedBranch, setSelectedBranch] = useState(null);

    const [formValues, setFormValues] = useState({
        transportationPrice: 0,
        cityId: null,
        branchId: null,
    });

    const [addErrors, setAddErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

   
    const handleNumberChange = (e) => {
        const { name, value } = e.target;
        const numericValue = value.replace(/,/g, "");

        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: numericValue,
        }));
    };

    const validateForm = () => {
        const newAddErrors = {};

        if (!formValues.transportationPrice) {
            newAddErrors.transportationPrice = t('transportationPriceRequired');
        }

        if (isNaN(formValues.transportationPrice)) {
            newAddErrors.transportationPrice = t('transportationPriceNumber');
        }

        if (!formValues.cityId) {
            newAddErrors.city = t('cityRequired');
        }

        if (!formValues.branchId) {
            newAddErrors.branch = t('branchRequired');
        }

        setAddErrors(newAddErrors);

        return Object.keys(newAddErrors).length === 0;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isLoading) return;

        if (validateForm()) {
            try {
                setIsLoading(true);
                const data = await CityPriceService.add(formValues);
                if (data.status === 200) {
                    setPopupMsg(data.data.message);
                    setPopupType('success');
                    setShowPopup(true);
                    handleReload();
                    setFormValues({ transportationPrice: 0 });
                    setSelectedCity(null);
                    setSelectedBranch(null);
                }

                setAddErrors({});
            } catch (error) {
                if (error.response?.status === 400) {
                    const responseErrors = error.response.data || {};
                    const formattedErrors = {};

                    Object.keys(responseErrors).forEach((field) => {
                        formattedErrors[field] = responseErrors[field];
                    });

                    setAddErrors(formattedErrors);
                } else {
                    setPopupMsg(error.response.data.error);
                    setPopupType('error');
                    console.error("An unexpected error occurred:", error);
                    setAddErrors({ general: error.response.data.error });
                }
            } finally {
                setIsLoading(false);
            }
        }
    };

    return (
        <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
                width: '100%',
                bgcolor: 'background.paper',
                borderRadius: 2,
                border: 1,
                borderColor: theme.palette.customGrey.borderInput,
                p: isTablet ? 2 : 4,
            }}
        >
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                <Typography id="transition-modal-title" variant="h6" component="h2">
                    {t('addCityPrice')}
                </Typography>
            </Box>

            <CityDropdown
                helperText={addErrors.city}
                error={!!addErrors.city}
                setFormValues={setFormValues}
                isFilter={false}
                selectedCity={selectedCity}
                setSelectedCity={setSelectedCity}
            />

            <BranchDropdown
                helperText={addErrors.branch}
                error={!!addErrors.branch}
                setFormValues={setFormValues}
                isFilter={false}
                selectedBranch={selectedBranch}
                setSelectedBranch={setSelectedBranch}
            />

            <CustomInput
                label={t('transportationPrice')}
                placeholder={t('transportationPriceHere')}
                name="transportationPrice"
                type='text'
                value={formValues.transportationPrice ? Number(formValues.transportationPrice).toLocaleString() : 0}
                error={!!addErrors.transportationPrice}
                helperText={addErrors.transportationPrice}
                onChange={handleNumberChange}
            />


            {addErrors.general && (
                <Typography align="center" color="error" variant="body2" sx={{ mt: 2 }}>
                    {addErrors.general}
                </Typography>
            )}

            <Box sx={{
                display: 'flex', justifyContent: 'center', alignItems: 'center',
                mt: addErrors.general ? 2 : 4
            }}>
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{ textTransform: 'none', width: 140, height: 40 }}
                >
                    {isLoading ? <CircularProgress color="secondary" size={28} /> :
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <p>{t('add')}</p>
                            <AddIcon fontSize="small" sx={{ mx: 0.4 }} />
                        </Box>
                    }
                </Button>
            </Box>
        </Box>
    );
}

export default AddCityPriceBox;
